import { Injectable, inject } from '@angular/core';
import { PERMISSION_FIELD } from '../models/permission.model';
import type { Permission } from '../models/permission.model';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly authService = inject(AuthService);

  // Sin signal propio: lee directo de AuthService.permissions, que login()/register()/fetchMe()
  // ya mantienen actualizado — evita que la sesión real quede reflejada en dos sitios distintos.
  readonly permissions = this.authService.permissions;

  isAccountOwner(): boolean {
    return this.authService.currentUser()?.is_account_owner ?? false;
  }

  // isAccountOwner bypasea todos los permisos (CLAUDE.md §4) — se comprueba primero.
  hasPermission(code: Permission): boolean {
    if (this.isAccountOwner()) {
      return true;
    }
    const permissions = this.authService.permissions();
    return permissions ? Boolean(permissions[PERMISSION_FIELD[code]]) : false;
  }
}
